/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

const _extend = require('lodash/extend');

const Logger = require('./logger');
const Receiver = require('emarsys-integration-client').comm.Receiver;
const AlertApi = require('emarsys-integration-client').api.Alert;
const Transmitter = require('./comm/transmitter');
const DialogApi = require('./service/dialog_api');
const DialogFactory = require('./service/dialog_factory');
const connect = require('./connect');
const getFullUrlByTarget = require('./message_handler/get_full_url_by_target');
const MessageHandlerNavigate = require('./message_handler/navigate');
const messageHandlers = [
  require('./message_handler/confirm'), // Removed behind flipper: ui_integration_remove_confirm
  require('./message_handler/enable_button'), // only
  require('./message_handler/fit'), // Removed behind flipper: ui_integration_remove_fit
  require('./message_handler/get_url'), // Removed behind flipper: ui_integration_remove_get_full_url_by_target
  require('./message_handler/intercom_track_event'), // Removed: ui_integration_remove_intercom_track_event
  require('./message_handler/modal'),
  require('./message_handler/modal_close'), // Removed behind flipper: ui_integration_remove_modal_close
  require('./message_handler/navigate'), // Removed behind flipper: ui_integration_remove_navigate
  require('./message_handler/proxy'),
  require('./message_handler/refresh'), // Removed behind flipper: ui_integration_remove_refresh
  require('./message_handler/resize'),
  require('./message_handler/track') // Removed behind flipper: ui_integration_remove_track
];

window.Emarsys = window.Emarsys || (window.SUITE ? _extend(true, {}, window.SUITE) : {});
window.Emarsys.config = window.Emarsys.config || (window.SUITE.config ? _extend(true, {}, window.SUITE.config) : {});

let transmitter = new Transmitter({
  global: window,
  integrationId: 'EMARSYS',
  integrationInstanceId: 'EMARSYS'
});
let receiver = new Receiver(window);

window.Emarsys.integration = {
  messageToEmarsys: (...args) => {
    Logger.sendLog('window messageToEmarsys');
    transmitter.messageToEmarsys(...args);
  },
  messageToService: (...args) => {
    Logger.sendLog('window messageToService');
    transmitter.messageToService(...args);
  },
  addMessageHandler: (...args) => {
    Logger.sendLog('window addMessageHandler');
    receiver.addMessageHandler(...args);
  },
  alert: AlertApi.create(transmitter), // Add log later
  dialog: new DialogApi(transmitter, DialogFactory.create()),
  getFullUrlByTarget: ({ target, params }) => {
    // Causes problems in a datagrid on automation programs
    // Logger.sendLog('window getFullUrlByTarget', { target, params });
    return getFullUrlByTarget({ // same as get_url but not migrated yet
      sessionId: window.Emarsys.config.session_id,
      target,
      params
    });
  },
  navigate: (messageData) => {
    Logger.sendLog('window navigate', { messageData });
    let messageHandler = new MessageHandlerNavigate(window, null);
    return messageHandler.navigate({ data: messageData });
  },
  unload: {
    initialized: false
  }
};

messageHandlers.forEach(function(MessageHandlerClass) {
  let messageHandler = new MessageHandlerClass(window, transmitter);
  receiver.addMessageHandler(messageHandler.MESSAGE_EVENT, messageHandler.handleMessage.bind(messageHandler));
});

connect(window);




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./integration.js
 **/